import {Mall, Mds, GetAdminsServiceMerchandisersRequest, GetMallsMallNoRequest, MallDetail} from 'supporter';
import {MallState, MallMdsState, MallDetailState, GlobalMall} from '@/types';
import {api} from '@/api';
import {ActionContext} from 'vuex';
import moment from 'moment';

export default {
  namespaced: true,
  state: {malls: [], mallsMds: [], mall: {}},
  actions: {
    async fetchMalls({state, commit}: ActionContext<MallState, any>, refreshFlg: boolean = false): Promise<any> {
      if (!refreshFlg) {
        if (state.malls.length) {
          return;
        }
        const mallInfo = JSON.parse(window.localStorage.mallInfo || null);
        if (mallInfo) {
          const malls = mallInfo.filter((mall: Mall): boolean => mall.used && (mall.mallStatus === 'ACTIVE' || mall.mallStatus === 'BLOCKED'));
          commit('SET_MALLS', malls);
          return;
        }
      }

      const {data} = await api.getMalls();
      const malls = data.filter((mall: any): boolean => mall.used && (mall.mallStatus === 'ACTIVE' || mall.mallStatus === 'BLOCKED'));
      commit('SET_MALLS', malls);
      window.localStorage.mallInfo = JSON.stringify(data);
    },
    async fetchMallsMds({commit}: ActionContext<MallMdsState, any>, mdsrequest: GetAdminsServiceMerchandisersRequest): Promise<any> {
      const {data} = await api.getAdminsServiceMerchandisers(mdsrequest);
      commit('SET_MALLSMDS', data);
    },
    async fetchMallsMallNo({commit}: ActionContext<MallDetailState, any>, request: GetMallsMallNoRequest): Promise<void> {
      const {data} = await api.getMallsMallNo(request);
      commit('SET_MALL_DETAIL', data);
    }
  },
  mutations: {
    SET_MALLS(state: MallState, malls: Mall[]): void {
      state.malls = malls;
    },
    SET_MALLSMDS(state: MallMdsState, mallsMds: Mds[]): void {
      state.mallsMds = mallsMds;
    },
    SET_MALL_DETAIL(state: MallDetailState, mallDetail: MallDetail): void {
      state.mallDetail = mallDetail;
    }
  },
  getters: {
    mallByMallNo: (state: MallState): any => (mallNo: number): Mall => state.malls.find((mall: Mall): boolean => mall.mallNo === mallNo),
    /** 글로벌 몰 표기 + 전부 가져오기 */
    mallsGlobal(state: MallState): GlobalMall[] {
      const mallInfo = state.malls ? JSON.parse(JSON.stringify(state.malls)) : JSON.parse(window.localStorage.mallInfo || null);

      if (!mallInfo) {
        return [];
      }

      return mallInfo.map((mall) => ['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(mall.globalMallType) ? {...mall, mallName: `[글로벌${mall.globalMallType === 'SEPARATED_GLOBAL_MAIN' ? 'M' : 'S'}]${mall.mallName}`} : mall);
    },
    /** 글로벌 몰 표기 + 서브몰 제외 */
    mallsGlobalExceptSubMall(state: MallState): GlobalMall[] {
      const mallInfo = state.malls ? JSON.parse(JSON.stringify(state.malls)) : JSON.parse(window.localStorage.mallInfo || null);

      if (!mallInfo) {
        return [];
      }

      return mallInfo
        .filter((mall) => mall.globalMallType !== 'SEPARATED_GLOBAL_SUB')
        .map((mall) => mall.globalMallType === 'SEPARATED_GLOBAL_MAIN' ? {...mall, mallName: `[글로벌M]${mall.mallName}`} : mall);
    },
    /** 글로벌 몰 제외 */
    mallsExceptGlobalMall(state: MallState): Mall[] {
      const mallInfo = state.malls ? JSON.parse(JSON.stringify(state.malls)) : JSON.parse(window.localStorage.mallInfo || null);

      if (!mallInfo) {
        return [];
      }

      return mallInfo.filter((mall) => ['LOCAL', 'INTEGRATED_GLOBAL'].includes(mall.globalMallType))
    },
    malls(state: MallState): Mall[] {
      if (state.malls) {
        return JSON.parse(JSON.stringify(state.malls));
      }

      const mallInfo = JSON.parse(window.localStorage.mallInfo || null);
      if (mallInfo) {
        return mallInfo;
      }
      return undefined as any;
    },
    mallsMds(state: MallMdsState): Mds[] {
      return state.mallsMds;
    },
    mallDetail(state: MallDetailState): MallDetail {
      return state.mallDetail;
    },
    /**
     * @mallNameAndValues Get simple mall information
     * @param  state
     *
     * @return [...{name: mallName, value: mallNo}]
     */
    mallNameAndValues(state: MallState): {name: string; value: string}[] {
      return state.malls
        .concat()
        .filter(
          (mall: Mall): Mall => {
            if (mall.used) return mall;
          }
        )
        .map((mall: Mall): {name: string; value: string} => ({
          name: String(mall.mallName),
          value: String(mall.mallNo)
        }));
    },
    /**
     * @mallsSortedByCreationDate 몰 생성시간 최신순 정렬 reference by shopby-pro-admin
     */
    mallsSortedByCreationDate(state: MallState): Mall[] {
      const sortByLatestCreationDate = (a, b): number => {
        const dateL = moment(a.createdDateTime)
          .toDate()
          .getTime();
        const dateR = moment(b.createdDateTime)
          .toDate()
          .getTime();
        return dateL < dateR ? 1 : -1;
      };
      return [...state.malls].sort(sortByLatestCreationDate);
    }
  }
};
